import styles from './SpecsContainer.module.css';
import Image from 'next/image';
import { ProductDetailInfo } from "../../../types/Product";
export const SpecsContainer = ({
  index,
  productDetailInfoList
}: {
  index: number;
  productDetailInfoList: any[];
}) => {
  delete productDetailInfoList[index]?.id;
  const productDetail = productDetailInfoList[index];

  //This part will construct 3 columns to display on the product detail section.
  const productDetailEntries = Object.entries(productDetail) as [keyof ProductDetailInfo, string][];
  const productDetailColumn1 = productDetailEntries.slice(0, 3);
  const productDetailColumn2 = productDetailEntries.slice(3, 6);
  const productDetailColumn3 = productDetailEntries.slice(6, 9);
  return <div className={styles.productDetailColumn} data-sentry-component="SpecsContainer" data-sentry-source-file="SpecsContainer.tsx">
            {productDetailEntries.map(([key, value]) => <div className={styles.productDetailRow} key={key}>
                    <Image src={`/productDetailIcon/${key}.svg`} alt="detail" className={styles.productDetailIcon} width={24} height={24} />
                    <p className={styles.productDetailText}>{key}:  {value}</p>
                </div>)}
        </div>;
};